import { ActionIcon, Menu } from '@cowbell/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';

export interface ConnectorMenuItem {
  readonly label: string;
  readonly onClick: () => void;
  readonly danger?: boolean;
}

interface ConnectorActionsMenuProps {
  /** The connector's name, for the trigger's accessible label. */
  readonly name: string;
  readonly items: readonly ConnectorMenuItem[];
}

export default function ConnectorActionsMenu({
  name,
  items,
}: ConnectorActionsMenuProps) {
  return (
    <Menu position="bottom-end" withinPortal>
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          color="gray"
          aria-label={`More actions for ${name}`}
        >
          <FontAwesomeIcon icon={faEllipsisVertical} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {items.map((item) => (
          <Menu.Item
            key={item.label}
            color={item.danger ? 'red' : undefined}
            onClick={item.onClick}
          >
            {item.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
